var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-body login-card-body" },
      [
        _c("login-form", {
          ref: "form",
          attrs: { errors: _vm.errors },
          on: { submit: _vm.onSubmit },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }